import i18next from 'i18next'

/** Get all checkbox for a given name */
const getAllCheckbox = (name: string): HTMLInputElement | null => {
  return document.querySelector(`div.pubFacets input[id="${name}Alla"]`)
}

/** Get all inputs with a specific name */
const getInputsWithName = (name: string): NodeListOf<HTMLInputElement> => {
  return document.querySelectorAll(`div.pubFacets input[name="${name}"]`)
}

/** Append a filter item to the filter box */
const appendFilterItem = (filterBox: HTMLElement, name: string, value: string): void => {
  const filterItem = document.createElement('div')
  filterItem.className = 'filteritem'
  filterItem.dataset.name = name
  filterItem.dataset.value = value

  filterItem.innerHTML = `
    ${value}
    <div class="removeitem" role="button" tabindex="0">
      <span class="fa fa-times" aria-hidden="true"></span>
      <span class="sr-only">${i18next.t('remove-filter')} ${value}</span>
    </div>
  `

  filterBox.appendChild(filterItem)
}

/** Remove a filter item from the filter box */
const removeFilterItem = (filterBox: HTMLElement, value: string): void => {
  const itemToRemove = filterBox.querySelector(`.filteritem[data-value="${value}"]`)
  itemToRemove?.remove()
}

/** Update visibility of filter buttons based on filter items */
const updateFilterButtonsVisibility = (filterBox: HTMLElement | null): void => {
  if (!filterBox) return
  const hasFilterItems = filterBox.querySelectorAll('.filteritem').length > 0
  const filterButton = document.querySelector('.filterbutton') as HTMLElement | null
  const clearFilterBtn = document.querySelector('.clearfilter') as HTMLElement | null

  if (!hasFilterItems && filterButton && !filterButton.classList.contains('hidden')) {
    filterButton.classList.add('hidden')
    clearFilterBtn?.classList.add('hidden')
  } else if (filterButton && filterButton.classList.contains('hidden')) {
    filterButton.classList.remove('hidden')
    clearFilterBtn?.classList.remove('hidden')
  }
}

/** Handle checkbox unchecked state */
const handleUncheckedState = (
  input: HTMLInputElement,
  name: string,
  value: string,
  filterBox: HTMLElement | null,
): void => {
  if (!filterBox) return

  if (input.id.includes(i18next.t('all'))) {
    const inputsWithName = getInputsWithName(name)
    inputsWithName.forEach((el) => {
      el.checked = false
      filterBox.querySelectorAll(`.filteritem[data-name="${name}"]`).forEach((item) => item.remove())
    })
  } else {
    const allCheckbox = getAllCheckbox(name)
    if (allCheckbox) allCheckbox.checked = false

    if (value) {
      removeFilterItem(filterBox, value)
    }
  }
}

/** Handle checkbox checked state */
const handleCheckedState = (
  input: HTMLInputElement,
  name: string,
  value: string,
  filterBox: HTMLElement | null,
): void => {
  if (!filterBox) return

  if (input.id.includes(i18next.t('all'))) {
    const inputsWithName = getInputsWithName(name)
    inputsWithName.forEach((el) => {
      const elValue = el.getAttribute('value') || ''
      if (elValue && elValue !== i18next.t('all') && !filterBox.querySelector(`.filteritem[data-value="${elValue}"]`)) {
        el.checked = true
        appendFilterItem(filterBox, name, elValue)
        updateFilterButtonsVisibility(filterBox)
      }
    })
  } else {
    const allCheckbox = getAllCheckbox(name)
    if (allCheckbox) allCheckbox.checked = false

    if (value && value !== i18next.t('all') && !filterBox.querySelector(`.filteritem[data-value="${value}"]`)) {
      appendFilterItem(filterBox, name, value)
      updateFilterButtonsVisibility(filterBox)
    }
  }
}

/** Handle checkbox click event */
const handleCheckboxClick = function (this: HTMLInputElement, filterItems: HTMLElement | null): void {
  const input = this
  const name = input.getAttribute('name') || ''
  const value = input.getAttribute('value') || ''

  if (!input.checked) {
    handleUncheckedState(input, name, value, filterItems)
    return
  }

  handleCheckedState(input, name, value, filterItems)
}

/** Remove a filter item when clicking the remove button */
const removeItem = (
  removeButton: HTMLElement,
  filterItems: HTMLElement | null,
  filterButton: HTMLElement | null,
  clearFilterBtn: HTMLElement | null,
): void => {
  if (!filterItems) return

  const parent = removeButton.parentElement as HTMLElement | null
  const value = parent?.dataset.value || ''
  const name = parent?.dataset.name || ''

  removeFilterItem(filterItems, value)

  const valueInput = document.querySelector(`div.pubFacets input[value="${value}"]`) as HTMLInputElement | null
  const nameInput = document.querySelector(`div.pubFacets input[id="${name}"]`) as HTMLInputElement | null

  if (valueInput) valueInput.checked = false
  if (nameInput) nameInput.checked = false

  const remainingItems = filterItems.querySelectorAll('.filteritem').length
  if (remainingItems < 1 && filterButton && !filterButton.classList.contains('hidden')) {
    filterButton.classList.add('hidden')
    clearFilterBtn?.classList.add('hidden')
    const productListForm = document.querySelector('.productlistform') as HTMLFormElement | null
    productListForm?.submit()
  }
}
const expandFilterButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.expand-btn')

document.addEventListener('click', (e: Event): void => {
  expandFilterButtons.forEach((button: HTMLButtonElement): void => {
    // Check if the menu is expanded and the click is outside the filter
    if (button.getAttribute('aria-expanded') === 'true') {
      const filterButton = button.parentElement as HTMLLegendElement | null
      const filter = filterButton?.parentElement

      // If click is outside the filter div, collapse it
      if (filter && !filter.contains(e.target as Node)) {
        button.classList.remove('extended')
        button.setAttribute('aria-expanded', 'false')

        const filterOptions = filter.querySelectorAll('.filter-option')
        filterOptions.forEach((element) => element.classList.add('collapsed'))
      }
    }
  })
})

document.addEventListener('DOMContentLoaded', (): void => {
  // Expand filter buttons functionality
  expandFilterButtons.forEach((button: HTMLButtonElement): void => {
    button.addEventListener('click', function (): void {
      this.classList.toggle('extended')
      const isExpanded: boolean = this.getAttribute('aria-expanded') === 'true'
      this.setAttribute('aria-expanded', String(!isExpanded))

      const filterButton = this.parentElement as HTMLLegendElement | null
      const filter = filterButton?.parentElement

      if (filter) {
        const filterOptions = filter.querySelectorAll('.filter-option')
        filterOptions.forEach((element) => {
          const checkbox = element.querySelector('input')

          if (checkbox instanceof HTMLInputElement) {
            const newTabIndex = checkbox.getAttribute('tabindex') === '0' ? '-1' : '0'
            checkbox.setAttribute('tabindex', newTabIndex)
          }
          element.classList.toggle('collapsed')
        })
      }
    })
  })

  // Select core elements once
  const filterButton = document.querySelector('#filterbutton') as HTMLElement | null
  const clearFilterBtn = document.querySelector('.clearfilter') as HTMLElement | null
  const filterItems = document.querySelector('.filteritems') as HTMLElement | null

  // Filter items event listeners
  if (filterItems) {
    filterItems.addEventListener('click', (event) => {
      const target = event.target as HTMLElement
      const removeItemContainer = target.closest('.removeitem') as HTMLElement | null
      if (removeItemContainer) {
        removeItem(removeItemContainer, filterItems, filterButton, clearFilterBtn)
      }
    })

    filterItems.addEventListener('keypress', (event) => {
      const target = event.target as HTMLElement
      const removeItemContainer = target.closest('.removeitem') as HTMLElement | null
      if (event.key === 'Enter' && removeItemContainer) {
        removeItem(removeItemContainer, filterItems, filterButton, clearFilterBtn)
      }
    })
  }

  // Clear filter button functionality with form submission
  clearFilterBtn?.addEventListener('click', () => {
    const inputs = document.querySelectorAll('div.pubFacets input') as NodeListOf<HTMLInputElement>
    inputs.forEach((input) => {
      input.checked = false
      if (filterItems) {
        filterItems.querySelectorAll(`.filteritem[data-name="${input.name}"]`).forEach((item) => item.remove())
      }
    })
    updateFilterButtonsVisibility(filterItems)
    const productListForm = document.querySelector('.productlistform') as HTMLFormElement | null
    if (productListForm) {
      productListForm.submit()
    }
  })

  // Checkbox event listeners
  const inputs = document.querySelectorAll('div.pubFacets input') as NodeListOf<HTMLInputElement>
  inputs.forEach((input) => {
    input.addEventListener('click', () => handleCheckboxClick.call(input, filterItems))
  })
})
